import React from 'react'
import HeroSection from '../../components/about/HeroSection'
import MissionStatement from '../../components/about/MissionStatement'
import AdvantageSection from '../../components/about/AdvantageSection'
import TeamSection from '../../components/about/TeamSection'

const About = () => {
  return (
    <div>
        <HeroSection />
        <MissionStatement />
        <AdvantageSection />
        <TeamSection />
    </div>
  )
}

export default About